
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import moment from 'moment';

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Select, ToggleSwitch } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Alert } from '@mui/material';
import { getStatusOptions } from "Core/data/Helpers"
import { DatePicker } from "@gpstrackit/gtc-react-controls";

//Actions
import {
    accountsChangeStatusScheduledRequest,
    accountsChangeStatusRequest,
    clearRedux,
} from 'Redux/actions';

//Helpers
import { HasPermission } from "Core/security"

const ChangeStatus = (props) => {
    const { getCompany, company } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);
    let now = moment.utc();

    const [status, setStatus] = useState(null);
    const [scheduled, setScheduled] = useState(false);
    const [date, setDate] = useState(now.add(12, 'hours'));
    const { openModal, loading, result, account, schedule } = useSelector(state => state.changeStatusAccountRedux);
    const user = useSelector(state => state.securityRedux.user);

    const closeModal = () => {
        dispatch(clearRedux("ACCOUNTS_CHANGE_STATUS"));
        setStatus(null)
        setScheduled(false)
        setDate(now.add(12, 'hours'))
    }

    let statusLabels = [
        {
            id: 1,
            label: "Active"
        },
        {
            id: 2,
            label: "Voluntary Suspension"
        },
        {
            id: 3,
            label: "Involuntary Suspesion"
        },
        {
            id: 4,
            label: "Cancelled"
        }
    ]

    const applyChanges = () => {
        if (!scheduled) {
            dispatch(accountsChangeStatusRequest({
                id: account?.id,
                status: status?.id
            }))
        } else {
            let newStatus = statusLabels.find((item) => item.id === status?.id)
            let payload = {
                entityName: "Account",
                entities: [{ companyId: account?.id, entityId: account?.id }],
                scheduledActions: [{
                    data: JSON.stringify({ newStatusId: status?.id, newStatusName: newStatus.label }),
                    scheduleOn: moment(date).format('YYYY-MM-DD')
                }]
            }
            dispatch(accountsChangeStatusScheduledRequest(payload))
        }
    }

    useEffect(() => {
        if (result) {
            if (result?.id) {
                NotificationManager.success(
                    messages['account_change_the_status_has_been_changed'],
                    messages['account_change_status_title'],
                    3000,
                );
                closeModal();
                getCompany && getCompany();
            } else if (result?.error) {
                NotificationManager.success(
                    messages['account_change_it_was_not_possible_to_change_the_status'],
                    messages['account_change_status_title'],
                    3000,
                );
                dispatch(clearRedux("ACCOUNTS_CHANGE_STATUS", { result: null }));
            }
        }
    }, [result]);

    useEffect(() => {
        if (schedule) {
            if (!schedule?.error) {
                NotificationManager.success(
                    messages['account_change_status_programmed'],
                    messages['change_status_title'],
                    3000,
                );
                closeModal();
            } else if (schedule?.error) {
                NotificationManager.error(
                    schedule?.error.includes("Entities") ? messages['change_status_error_scheduled_action'] : messages['change_status_error_scheduled'],
                    messages['change_status_title'],
                    3000,
                );
                dispatch(dispatch(clearRedux("ACCOUNTS_CHANGE_STATUS", { schedule: null })));
            }
        }
    }, [schedule])


    let statusValidation = company?.status === status?.id;

    return (
        <Modal
            open={openModal}
            title={messages['account_change_status_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        <Select
                            id="change-status-id"
                            valueField="id"
                            textField="label"
                            value={status}
                            label={messages['account_change_status_label']}
                            placeholder={messages['account_change_status_label']}
                            options={getStatusOptions(messages).filter((item) => item.label !== "RMA")}
                            onChange={(value) => setStatus(value)}
                            required
                            requiredMessage={messages['required_field']}
                        />
                        {
                            statusValidation &&
                            <Alert
                                style={{ marginTop: 5 }}
                                severity="warning"
                            >
                                {messages['account_change_same_status']}
                            </Alert>
                        }
                        {
                            HasPermission(user, "schact", "c") ? (
                                <>
                                    <div style={{ marginTop: 12, width: '100%', display: 'flex', alignItems: 'center' }}>
                                        <label style={{ marginRight: 7, marginTop: 1 }} className="input-normal-label">{messages['edit_scheduled_scheduled_at']}</label>
                                        <ToggleSwitch
                                            id="unit-type-uses-sim"
                                            large
                                            blueToggle
                                            optionLabels={[messages['common_schedule'], messages['common_now']]}
                                            checked={scheduled}
                                            onChange={(checked) => setScheduled(checked)}
                                        />
                                    </div>
                                    {
                                        scheduled ? (
                                            <div className="scheduled-actions-picker">
                                                <DatePicker
                                                    calendarPosition="bottom"
                                                    format="MMMM DD, yyyy"
                                                    minDate={now.add(12, 'hours')}
                                                    onChange={(date) => setDate(date)}
                                                    placeholder={messages['feature_tab_select_date']}
                                                    showButtons
                                                    style={{ height: '42px', marginTop: 5 }}
                                                    timeZone={0}
                                                    value={date}
                                                />
                                            </div>
                                        ) : <></>
                                    }
                                </>
                            ) : <></>
                        }
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    disabled={statusValidation}
                    className="btn-dark-blue"
                    onClick={() => formRef?.current?.submit()}
                >
                    {messages['account_change_label']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ChangeStatus;